import { Component, inject, Signal, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MDIconComponent } from '@melodic-ui/components';
import { RouterModule } from '@angular/router';
import { BreadcrumbService } from './breadcrumb.service';

export type BreadcrumbItem = {
	linkText?: string;
	linkIcon?: string;
	routerLink?: string;
	component?: Type<Component>;
	componentInputs?: Record<string, unknown>;
};

@Component({
	selector: 'lb-breadcrumb',
	standalone: true,
	imports: [CommonModule, RouterModule, MDIconComponent],
	templateUrl: './breadcrumb.component.html',
	styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent {
	private _breadcrumbService: BreadcrumbService = inject(BreadcrumbService);

	public breadcrumbItems: Signal<BreadcrumbItem[]> = this._breadcrumbService.breadcrumbItems;
}
